var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BimContainer',[_c('BimRow',{attrs:{"justify":"center"}},[_c('BimCol',_vm._b({staticClass:"mx-auto"},'BimCol',_vm.sizes,false),[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }